/* eslint-disable */
/*
This is the file that maps a string to a screen.
*/

import { StackNavigator } from "react-navigation"
import React, { Component } from 'react'
import { Easing, Animated } from 'react-native'
import LoginScreen from "../Containers/LoginScreen"
import ChangePasswordScreen from "../Containers/ChangePasswordScreen"
//import UserListScreen from "../Containers/UserListScreen"
//import PostWallScreen from "../Containers/PostWallScreen"
//import InviteFriendScreen from "../Containers/InviteFriendScreen"
//import CameraScreen from "../Containers/CameraScreen"
//import PapalScreen from "../Containers/PapalScreen"
//import MyShopDeliveryScreen from "../Containers/MyShopDeliveryScreen"
//import OrderConfirmScreen from "../Containers/OrderConfirmScreen"
//import KargoelyticDetailScreen from "../Containers/KargoelyticDetailScreen"
//import MapWallScreen from "../Containers/MapWallScreen"
import Outofdate from "../Containers/outofdate"
//import ProfileScreen from "../Containers/ProfileScreen"
//import UserDetailsScreen from "../Containers/UserDetailsScreen"
//import MessagesScreen from "../Containers/MessagesScreen"
//import MessagesWebScreen from "../Containers/MessagesWebScreen"
//import KargoeChatScreen from "../Containers/KargoeChatScreen"
import SettingsScreen from "../Containers/SettingsScreen"
import LaunchScreen from "../Containers/LaunchScreen"
import WebViewScreen from "../Containers/WebViewScreen"
//import AboutScreen from "../Containers/AboutScreen"
//import PaymentOptionsScreen from "../Containers/PaymentOptionsScreen"
//import DeliveryAddressesScreen from "../Containers/DeliveryAddressesScreen"
//import KargoelyticsScreen from "../Containers/KargoelyticsScreen"
//import OneVendorCoupons from "../Containers/OneVendorCoupons"
//import OffersMapScreen from "../Containers/OffersMapScreen"
//import HappeningScreen from "../Containers/HappeningScreen"
import FollowScreen from "../Containers/FollowScreen"
//import ProfilePostScreen from "../Containers/ProfilePostScreen"
import ExploraScreen from "../Containers/ExploraScreen"
//import KargortagViewPostScreen from "../Containers/KargortagViewPostScreen"
//import KargoetagViewPostV2Screen from "../Containers/KargoetagViewPostV2Screen"
//import DicoverDetailScreen from "../Containers/DicoverDetailScreen"
//import DiscoverDetailV2Screen from "../Containers/DiscoverDetailV2Screen"
//import BarCoderScreen from "../Containers/BarCoderScreen"
import EditPostScreen from "../Containers/EditPostScreen"
import styles from "./Styles/NavigationStyles"
import SplashScreen from '../Containers/SplashScreen'
import AuthenticationScreen from '../Containers/AuthenticationScreen'
//import ProfileSetupScreen from '../Containers/ProfileSetupScreen'
// import SignUpScreen from '../Containers/SignUpScreen'
import SignUpScreen from '../Containers/SignUpV2Screen'
//import BioSetupScreen from '../Containers/BioSetupScreen'
//import SigupFacebookScreen from '../Containers/SigupFacebookScreen'
//import PushNotificationSettingScreen from "../Containers/PushNotificationSettingScreen";

//import KargoePasswordAndTouchIdScreen from '../Containers/KargoePasswordAndTouchIdScreen'
import ProductDescriptionScreen from '../Containers/ProductDescriptionScreen'
//import KargoeCareScreen from '../Containers/KargoeCareScreen'
//import PostCommentsAndLovesScreen from '../Containers/PostCommentsAndLovesScreen'
import PostViewScreen from '../Containers/PostViewScreen'
//import SocialSharingScreen from '../Containers/SocialSharingScreen'
//import MessageDetailScreen from '../Containers/MessageDetailScreen'
//import TrackPackageScreen from '../Containers/TrackPackageScreen'
import ForgetPassScreen from '../Containers/ForgetPassScreen'
//import SendDirectScreen from '../Containers/SendDirectScreen'

//import BasicWallScreen from "../Containers/BasicWallScreen"
import PostWallV2Screen from "../Containers/PostWallV2Screen"
import ProfileWallV2Screen from "../Containers/ProfileWallV2Screen"
//import DebugScreen from "../Containers/DebugScreen"
//import ShoppableVariantScreen from "../Containers/ShoppableVariantScreen"
import BlankScreen from "../Containers/BlankScreen"
//import LiveBroadcastScreen from "../Containers/LiveBroadcastScreen"
//import FinishedPurchase from "../Containers/FinishedPurchase"

const transitionConfig = (toRoute, fromRoute) => {
  return {

    screenInterpolator: sceneProps => {
      const { layout, position, scene, index, scenes } = sceneProps
      const toIndex = index
      const thisSceneIndex = scene.index
      const width = layout.initWidth
      const height = layout.initHeight

      const translateY = position.interpolate({
        inputRange: [thisSceneIndex - 1, thisSceneIndex, thisSceneIndex + 1],
        outputRange: [height, 0, 0]
      })




      const slideInFromBottom = { transform: [{ translateY }] }
      const slideCamera = {
        transform: [{
          translateX: position.interpolate({
            inputRange: [thisSceneIndex - 1, thisSceneIndex],
            outputRange: [-width, 0],
          }),
        }]
      }



      const last = scenes[scenes.length - 1];

      if (scene.route.routeName === "exploraViewPost" || scene.route.routeName === "product"
        || scene.route.routeName === "discoverDetail" ||
        scene.route.routeName === "postCommentsAndLoves"
        || scene.route.routeName === "myShopDelivery"
        || scene.route.routeName === "kargoelyticDetail"
        || scene.route.routeName === "trackingPage"
        || scene.route.routeName === "exploraViewPostV2"
        || scene.route.routeName === "discoverDetailV2"
        || scene.route.routeName === "mapwall"
      ) {
        return slideInFromBottom
      }
      if (scene.route.routeName === "barCoder" && fromRoute) {
        const isBack = fromRoute.navigation.state.index >= toRoute.navigation.state.index;
        const translateX = position.interpolate({
          inputRange: [thisSceneIndex - 1, thisSceneIndex, thisSceneIndex + 1],
          outputRange: [width, 0, 0]
        })
        const slideFromRight = { transform: [{ translateX }] }

        return isBack ? slideFromRight : {}
      }



        const translateX = position.interpolate({
          inputRange: [thisSceneIndex - 1, thisSceneIndex, thisSceneIndex + 1],
          outputRange: [width, 0, 0]
        })
        const slideFromRight = { transform: [{ translateX }] }
        return slideFromRight


    },
  }
}

// fader
let MyTransition = (index, position) => {
  //console.log("in my transition")
  let scene = index
  const inputRange = [index - 1, index, index + 1];
  const opacity = position.interpolate({
      inputRange,
      outputRange: [0, 1, 1],
  });

  const scaleY = position.interpolate({
      inputRange,
      outputRange: ([0, 1, 1]),
  });



  const translateX = position.interpolate({
    inputRange: [0, 1],
    outputRange: [320, 0],
  })
  

  //return { transform: [ { translateX } ] }

  
  return {
      opacity,
      
      transform: [
      translateX
      ] 
      
  };
  
}
let TransitionConfiguration = () => {
  //console.log("in transition configuration")
  return {
    transitionSpec: {
      duration: 200,
      easing: Easing.out(Easing.poly(4)), 
      timing: Animated.timing,
      useNativeDriver: true,
    },
      // Define scene interpolation, eq. custom transition
      screenInterpolator: (sceneProps) => {

          //const {position, scene} = sceneProps;
          //const {index} = scene;

          //return MyTransition(index, position);

          const { layout, position, scene } = sceneProps
          const { index } = scene
  
          const height = layout.initHeight
          const width = layout.initWidth

          const translateX = position.interpolate({
            inputRange: [index - 1, index, index + 1],
            outputRange: [width, 0, 0],
          })

          const translateY = position.interpolate({
            inputRange: [index - 1, index, index + 1],
            outputRange: [height, 0, 0],
          })

  
          const opacity = position.interpolate({
            inputRange: [index - 1, index - 0.99, index],
            outputRange: [1, 1, 1],
          })
  
          return { opacity, transform: [{ translateX }] }

      }
  }
}

const AppNavigation = StackNavigator(
  {
    home: {
      screen: PostWallV2Screen, // PostWallScreen,
    },
    postwallv1: {
      screen: PostWallV2Screen, 
    },

  
   kargoelyticDetail : {
     screen : PostWallV2Screen, // KargoelyticDetailScreen
   },
    explora: {
      screen: ExploraScreen,
    },
    messages: {
      screen: PostWallV2Screen, // MessagesWebScreen,
    },
    chat:{
      screen:  PostWallV2Screen, // MessageDetailScreen
    },
    kargoeChat: {
      screen: PostWallV2Screen, // KargoeChatScreen,
    },
    kargoelytics: {
      screen: PostWallV2Screen, // KargoelyticsScreen,
    },
    oneVendorCoupons: {
      screen: PostWallV2Screen, // OneVendorCoupons,
    },
    offersMap: {
      screen: PostWallV2Screen, // OffersMapScreen
    },
    happening: {
      screen: PostWallV2Screen, // HappeningScreen,
    },
    profilePost: {
      screen: ProfileWallV2Screen, // ProfilePostScreen,
    },
    profilePost2: {
      screen: ProfileWallV2Screen, // ProfilePostScreen,
    },
    settings: {
      screen: SettingsScreen, 
    },
    login: {
      screen: LoginScreen
    },
    changePassword: {
      screen: ChangePasswordScreen
    },
    auth: {
      screen: AuthenticationScreen
    },
    profileSetup: {
      screen: PostWallV2Screen, // ProfileSetupScreen
    },
    signup: {
      screen: SignUpScreen
    },
    bioSetup: {
      screen: PostWallV2Screen, // BioSetupScreen
    },
    signupFacebook: {
      screen: PostWallV2Screen, // SigupFacebookScreen
    },
    about: {
      screen: PostWallV2Screen, // AboutScreen
    },

    kargoePasswordAndTouchID: {
      screen: PostWallV2Screen, // KargoePasswordAndTouchIdScreen
    },
    kargoeCare: {
      screen: PostWallV2Screen, // KargoeCareScreen
    },
    sendDirect: {
      screen: PostWallV2Screen, // SendDirectScreen
    },
    paymentOptions: {
      screen: PostWallV2Screen, // PaymentOptionsScreen
    },
    paypal: {
      screen: PostWallV2Screen, // PapalScreen
    },
    myShopDelivery: {
      screen: PostWallV2Screen, // MyShopDeliveryScreen
    },
    orderConfirm: {
      screen: PostWallV2Screen, // OrderConfirmScreen
    },
    deliveryAddresses: {
      screen: PostWallV2Screen, // DeliveryAddressesScreen
    },
    pushNotificationSetting: {
      screen: PostWallV2Screen, // PushNotificationSettingScreen
    },
    profile: {
      screen: ProfileWallV2Screen // ProfilePostScreen
    },
    profilewallv1: {
      screen: PostWallV2Screen, // ProfilePostScreen
    },
    outofdate: { screen: Outofdate },
    editPost: {
      screen: EditPostScreen
    },
    editProfile: {
      screen: PostWallV2Screen, // ProfileScreen
    },
    postDetail: {
      screen: ProfileWallV2Screen
    },
    follow: {
      screen: FollowScreen
    },
    WebViewScreen: {
      screen: WebViewScreen,
    },
    splash: {
      screen: SplashScreen
    },
    exploraViewPost: {
      screen: PostWallV2Screen, //  KargortagViewPostScreen
    },
    exploraViewPostV2: {
      screen: PostWallV2Screen, // KargoetagViewPostV2Screen
    },
    product: {
      screen: ProductDescriptionScreen
    },
    discoverDetail: {
      screen: PostWallV2Screen, // DicoverDetailScreen
    },
    discoverDetailV2: {
      screen: PostWallV2Screen, // DiscoverDetailV2Screen
    },
    barCoder: {
      screen: PostWallV2Screen, // BarCoderScreen
    },
    postCommentsAndLoves: {
      screen: PostWallV2Screen, // PostCommentsAndLovesScreen
    },
    socialSharing: {
      screen: PostWallV2Screen, // SocialSharingScreen
    },
    inviteFriend: {
      screen: PostWallV2Screen, // InviteFriendScreen
    },
    trackingPage : {
      screen : PostWallV2Screen, // TrackPackageScreen
    },
    forgetPass : {
      screen : ForgetPassScreen,
    },
    basic: {
      screen: PostWallV2Screen, // BasicWallScreen
    },
    debug: {
      screen: PostWallV2Screen, // DebugScreen
    },
    postwallv2: {
      screen: PostWallV2Screen
    },
    profilewallv2: {
      screen: ProfileWallV2Screen
    },
    shoppableVariant: {
      screen: PostWallV2Screen, // ShoppableVariantScreen
    },
    mapwall: {
      screen: PostWallV2Screen, // MapWallScreen
    },
    postView: {
      screen: PostViewScreen
    },
    blank: {
      screen: BlankScreen
    },
    liveBroadcast: {
      screen: PostWallV2Screen, // LiveBroadcastScreen
    },
    finishedPurchase: {
      screen: PostWallV2Screen, // FinishedPurchase
    }
  },
  {
    transitionConfig: TransitionConfiguration,
    mode: 'card',
    headerMode: 'none',
    initialRouteName: "splash",
    navigationOptions: {
      header: null,
      gesturesEnabled : false,
      
    },
  }
);

export default AppNavigation
